export let TransformNodeTypeName: string = "TransformNode";
export let MaterialNodeTypeName: string = "MaterialNode";
export let BatchesManagerNodeTypeName: string = "BatchesManagerNode";
export let RenderOptionNodeTypeName: string = "RenderOptionNode";
export let ShapeBatchNodeTypeName: string = "ShapeBatchNode";
export let TextureNodeTypeName: string = "TextureNode";

